import React from 'react';

export function DialogIcon(props: React.SVGProps<SVGSVGElement>) {
	return (
		<svg viewBox="0 0 38 36" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				fill="currentColor"
				d="M5 3h27.78a2 2 0 012 2v21.484a2 2 0 01-2 2h-5.26a8 8 0 00-4.24 1.216l-4.39 2.744L14.5 29.7a8 8 0 00-4.24-1.216H5a2 2 0 01-2-2V5a2 2 0 012-2zM0 5a5 5 0 015-5h27.78a5 5 0 015 5v21.484a5 5 0 01-5 5h-5.26a5 5 0 00-2.65.76l-5.45 3.406a1 1 0 01-1.06 0l-5.45-3.406a5 5 0 00-2.65-.76H5a5 5 0 01-5-5V5zm7.196 16.488a1 1 0 100 2h23.388a1 1 0 100-2H7.196zm-1-6.195a1 1 0 011-1h23.388a1 1 0 110 2H7.196a1 1 0 01-1-1zm1-8.197a1 1 0 100 2h23.388a1 1 0 100-2H7.196z"
			/>
		</svg>
	);
}
